<template>
  <div class="page-container">
    <div class="page-content pb-0">
      <!-- Cabeçalho -->
      <div class="page-header">
        <div class="d-flex align-items-center pb-3">
          <h1 class="text-white">
            <i class="mdi mdi-file-table-box-multiple-outline"></i> Painel de
            Cotações
          </h1>
          <div class="d-flex gap-2 ml-auto align-items-center">
            <!-- Dropdown Modo -->
            <b-dropdown
              variant="outline-white"
              toggle-class="btn btn-outline-white d-flex align-items-center"
              right
              class="mr-2 mb-2 mb-md-0"
            >
              <template #button-content>
                <i :class="getIcon(current_mode)"></i>
                <span class="d-none d-md-inline-block ml-2">
                  Modo {{ current_mode }}
                </span>
              </template>
              <b-dropdown-item @click="setViewMode('painel')">
                <i
                  class="mdi fa-fw mdi-file-table-box-multiple-outline mr-2"
                ></i>
                Modo Painel
              </b-dropdown-item>
              <b-dropdown-item @click="setViewMode('listagem')">
                <i class="mdi fa-fw mdi-view-list mr-2"></i>
                Modo Listagem
              </b-dropdown-item>
            </b-dropdown>
            <!-- Filtro / Limpar -->
            <div class="btn-group">
              <button
                class="btn btn-outline-white"
                v-b-modal.modal-filter
                title="Filtros"
              >
                <i class="fa fa-filter"></i>
                <span class="d-none d-md-inline-block ml-2">Filtros</span>
              </button>
              <button
                class="btn btn-outline-white"
                @click="cleanFilter()"
                title="Limpar Filtros"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="page-body">
        <div
          v-if="loading_page"
          class="overlay-modal d-flex align-items-center justify-content-center"
        >
          <b-spinner label="Loading..." variant="dark"></b-spinner>
        </div>

        <div class="kanban-board">
          <div
            class="kanban-list"
            v-for="column in columnsKanban()"
            :key="column"
            :data-list-id="column"
            :class="{
              'kanban-list-status-yellow':
                column === statusQuotationTypes.APPROVED,
              'kanban-list-status-green':
                column === statusQuotationTypes.ISSUED,
              'kanban-list-status-red': [
                statusQuotationTypes.DECLINED,
                statusQuotationTypes.ISSUE_FAILURE,
              ].includes(column),
            }"
          >
            <div class="kanban-list-header">
              <div class="kanban-list-title">
                {{
                  getEnumKeyByEnumValue(translateStatusQuotationTypes, column)
                }}
              </div>
              <div
                class="kanban-list-total-cards"
                :title="`Total: ${items[column]?.length || 0}`"
              >
                <i class="fa fa-copy"></i> {{ items[column]?.length || 0 }}
              </div>
            </div>
            <div
              class="kanban-list-cards"
              :class="{ 'is-loading': loadingColumns[column] }"
              @scroll="onScroll(column)"
              :ref="`kanbanListCards${column}`"
            >
              <draggable
                :list="items[column]"
                :group="{ name: 'kanban' }"
                ghost-class="dragging-shadow"
                @start="onCardGet"
                @end="onCardDrop"
                :disabled="true"
              >
                <div
                  v-for="q in items[column]"
                  :key="q.id"
                  class="kanban-card"
                  :data-card-id="q.id"
                >
                  <div class="kanban-card-data">
                    <div class="tomador smart-clip" :title="q.name">
                      {{ truncateText(q.name) }}
                    </div>
                    <div class="tomador smart-clip" :title="q.insured?.name">
                      {{ truncateText(q.insured?.name) }}
                    </div>
                    <div class="modalidade smart-clip">
                      {{
                        getEnumKeyByEnumValue(
                          insuranceCategoryTecnicTypes,
                          q.insurance_category_id
                        )
                      }}
                    </div>
                    <div class="pill-label pill-label-gray">
                      <span class="label">Prêmio</span>
                      <span class="value">{{
                        formatCurrency(q.guarantee?.contract_value || 0)
                      }}</span>
                    </div>
                  </div>
                  <div class="status-bar"></div>
                  <div class="kanban-card-actions">
                    <button
                      v-if="$can('quotation-show')"
                      class="button btn btn-sm btn-link text-secondary"
                      @click="redirect('details-quotation', q.id)"
                      v-b-tooltip.hover
                      title="Visualizar"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                </div>
              </draggable>

              <div
                v-if="loadingColumns[column]"
                class="overlay-column d-flex align-items-center justify-content-center"
              >
                <b-spinner small label="Carregando..."></b-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        v-model="show"
        id="modal-cotacao-status"
        size="lg"
        @hidden="onCloseModal"
      >
        <template #modal-title>
          <div>
            <div>
              <h5 class="modal-title" id="modal-cotacao-status-label">
                Status da cotação
              </h5>
              <p class="text-muted mb-0">Revise e altere o status da cotação</p>
            </div>
          </div>
        </template>
        <div v-if="element" class="modal-lg">
          <div class="p-3 pb-0">
            <div>
              <div class="row form">
                <div class="col-12 col-lg-4">
                  <label class="dbo-ui" for="">Tipo de seguro</label>
                  <p>
                    {{
                      getEnumKeyByEnumValue(
                        translateInsuranceTypes,
                        element.insurance_type_id
                      )
                    }}
                  </p>
                </div>
                <div class="col-12 col-lg-4">
                  <label class="dbo-ui" for="">Cliente</label>
                  <p>{{ element.insured ? element.insured.name : "---" }}</p>
                </div>
                <div class="col-12 col-lg-4">
                  <label class="dbo-ui" for="">Valor</label>
                  <p>
                    {{
                      formatCurrency(
                        element.guarantee ? element.guarantee.contract_value : 0
                      )
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-12 pb-4" v-if="isMaster()">
          <label class="dbo-ui" for="">Status</label>
          <select class="custom-select" v-model="dataForm.status">
            <option value="null">Selecione...</option>
            <option
              v-for="(status, index) in options"
              :key="index"
              :value="status.value"
            >
              {{ status.text }}
            </option>
          </select>
        </div>
        <template #modal-footer>
          <div>
            <button
              :disabled="disabledButtonChange"
              @click="changeStatusQuotation(element)"
              type="button"
              class="btn btn-primary"
            >
              <b-spinner v-if="loading" small></b-spinner> Alterar
            </button>
          </div>
        </template>
      </b-modal>

      <div class="modal">
        <b-modal
          ref="modalFilter"
          id="modal-filter"
          size="lg"
          class="mt-4"
          centered
        >
          <br />
          <template class="text-align-center" #modal-title>
            Filtrar Cotações
          </template>

          <form class="mb-2">
            <label>Tomador</label>
            <b-form-input
              class="mb-3"
              v-model="policy_holder"
              size="lg"
              id="name-input"
              required
            ></b-form-input>

            <label>Segurado</label>
            <b-form-input
              v-model="insured"
              class="mb-3"
              size="lg"
              id="name-input"
              required
            ></b-form-input>

            <label>Documento <small>(Apenas Números)</small></label>
            <b-form-input
              type="number"
              v-model="document"
              class="mb-3"
              size="lg"
              id="name-input"
              required
              v-on:keypress="isNumber($event)"
            ></b-form-input>
          </form>

          <template #modal-footer>
            <b-button @click="filterQuotations()" variant="outline-primary"
              >Filtrar <i class="fa fa-search"></i
            ></b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import quotationService from "@/services/quotation";
import commomsHelper from "@/mixins/commomsHelper";
import numericFormatterMixin from "@/mixins/numericFormatter";
import authenticationService from "@/services/authentication";
import draggable from "vuedraggable";
import statusQuotationTypes from "@/enums/statusQuotationTypes";
import translateInsuranceTypes from "@/enums/translate/insuranceTypes";
import translateStatusQuotationTypes from "@/enums/translate/statusQuotationTypes";
import insuranceCategoryTecnicTypes from "@/enums/translate/insuranceCategoryTecnicTypes";

export default {
  name: "My-Quotation",
  components: { draggable },
  mixins: [numericFormatterMixin, commomsHelper],
  data: () => ({
    insuranceCategoryTecnicTypes,
    translateStatusQuotationTypes,
    translateInsuranceTypes,
    statusQuotationTypes,
    loading: false,
    loading_page: false,
    element: null,
    dataForm: { status: null },
    items: {},
    perPage: 10,
    currentPage: { 3: 1, 4: 1, 5: 1, 6: 1, 7: 1 },
    hasMorePages: { 3: true, 4: true, 5: true, 6: true, 7: true },
    loadingColumns: { 3: false, 4: false, 5: false, 6: false, 7: false },
    current_mode: "painel",
  }),
  created() {
    this.loadAllColumns();
  },
  methods: {
    loadAllColumns() {
      this.loading_page = true;
      [3, 4, 5, 6, 7].forEach((column) => {
        this.getQuotations(column);
      });
    },
    columnsKanban() {
      return [3, 4, 5, 6, 7];
    },
    verifyStatusQuotation(status) {
      return (
        status === this.statusQuotationTypes.ISSUED ||
        status === this.statusQuotationTypes.APPROVED ||
        status === this.statusQuotationTypes.ISSUE
      );
    },
    changeStatusQuotation(element) {
      this.loading = true;
      this.resetAlert();
      quotationService
        .updateStatusQuotation(element.id, this.dataForm)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
        })
        .catch(() => {
          this.showError("Não foi possível mudar o status da cotação.");
        })
        .finally(() => {
          this.show = false;
          this.loading = false;
          this.clearColumns();
          this.loadAllColumns();
        });
    },
    redirect(routeName, id) {
      this.$router.push({ name: routeName, params: { quotationId: id } });
    },
    getQuotations(column) {
      if (!this.hasMorePages[column] || this.loadingColumns[column]) return;

      this.loadingColumns[column] = true;
      this.resetAlert();
      const currentPage = this.currentPage[column];
      quotationService
        .getKanbanData(this.formatFilters(column, currentPage))
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }

          const fetchedData = response.data.data || [];

          if (fetchedData.length < this.perPage) {
            this.hasMorePages[column] = false;
          }

          const existingItems = this.items[column] || [];
          this.$set(this.items, column, [...existingItems, ...fetchedData]);
        })
        .catch(() => {
          this.showError("Não foi possível recuperar as cotações.");
        })
        .finally(() => {
          this.loadingColumns[column] = false;
          this.loading_page = false;
        });
    },
    formatFilters(column, page) {
      return {
        policy_holder: this.policy_holder,
        insured: this.insured,
        document: this.document,
        page,
        per_page: this.perPage,
        type: column,
      };
    },
    getIcon(currentMode) {
      if (currentMode === "listagem") {
        return "fas fa-list mr-1";
      }
      if (currentMode === "painel") {
        return "mdi mdi-file-table-box-multiple-outline mr-2";
      }
      return "mdi fa-fw mdi-chart-arc mr-1";
    },
    onScroll(column) {
      const containerRef = this.$refs[`kanbanListCards${column}`];
      if (containerRef && containerRef.length > 0) {
        const container = containerRef[0];
        if (
          container.scrollTop + container.clientHeight >=
          container.scrollHeight - 10
        ) {
          this.loadMoreCards(column);
        }
      }
    },
    loadMoreCards(column) {
      if (this.hasMorePages[column] && !this.loadingColumns[column]) {
        this.currentPage[column] += 1;
        this.getQuotations(column);
      }
    },
    showModal(element, status = null) {
      this.element = element;
      this.dataForm.status = status;
      this.show = true;
    },
    filterQuotations() {
      this.clearColumns();
      this.loadAllColumns();
      this.$refs.modalFilter.hide();
    },
    cleanFilter() {
      this.policy_holder = "";
      this.insured = "";
      this.document = "";
      this.clearColumns();
      this.loadAllColumns();
    },
    clearColumns() {
      Object.keys(this.items).forEach((column) => {
        this.$set(this.items, column, []);
      });
      Object.keys(this.currentPage).forEach((column) => {
        this.currentPage[column] = 1;
        this.hasMorePages[column] = true;
      });
    },
    setViewMode(mode) {
      this.current_mode = mode;
      if (mode == "listagem") {
        this.redirect("list-quotation");
      }
    },
    isMaster() {
      return authenticationService.isMaster();
    },
    truncateText(text, maxChar = 28) {
      let length = text.length;
      return length > maxChar ? `${text.substring(0, maxChar)}...` : text;
    },
    getStatusKanban() {
      this.listStatusKanbanQuotation().forEach((element) => {
        this.options.push({
          value: element,
          text: this.getEnumKeyByEnumValue(
            this.translateStatusQuotationTypes,
            element
          ),
        });
      });
    },
    onCardGet(event) {
      this.from_column = event.from.getAttribute("data-list-id");
      this.original_index = event.oldIndex;
      this.quotation_selected =
        this.items[this.from_column][this.original_index] ?? null;
    },
    onCardDrop(event) {
      let to_column = event.to.getAttribute("data-list-id");
      this.new_index = event.newIndex;
      if (this.from_column == 5) {
        return;
      }
      if (this.quotation_selected) {
        this.showModal(this.quotation_selected, to_column);
      }
    },
    onCardMove(evt) {
      this.to_column = evt.to.dataset.listId;
      if (evt.from.dataset.listId === "5") {
        evt.from.classList.add("invalid-move");
        setTimeout(() => evt.from.classList.remove("invalid-move"), 1000);
        return false;
      }

      return true;
    },
    onCloseModal() {
      if (
        this.quotation_selected &&
        this.from_column !== null &&
        this.original_index !== null
      ) {
        const movedCard = this.items[this.to_column].splice(
          this.new_index,
          1
        )[0];
        this.items[this.from_column].splice(this.original_index, 0, movedCard);

        this.quotation_selected = null;
        this.from_column = null;
        this.original_index = null;
        this.to_column = null;
        this.new_index = null;
      }

      this.element = null;
      this.show = false;
    },
    showError(message) {
      this.$bvToast.toast(message, {
        title: "Erro",
        variant: "danger_toast",
        solid: true,
        toastClass: "custom-toast",
        bodyClass: "custom-toast-body",
        appendToast: true,
        autoHideDelay: 5000,
      });
    },
  },
};
</script>

<style scoped>
</style>
